import React, {useState,useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt} from '@fortawesome/free-solid-svg-icons';
import { Button,Grid,TextField,FormGroup,FormControlLabel,Checkbox,Link,FormControl,InputLabel,Select,MenuItem } from '@mui/material';
import BankinfoTab from './BankinfoTab';
import CardValidator from '../../Components/cardValidator';
import Loader from '../../Components/loader';
import MasterCardRupayForm from '../../Components/mastercardRupay';
import ImageComponents from '../../../../Shared/ImageComponents';

function LowCostEmiCreditCardDetails({secret , bankCode , mode , displayOrderNo ,  bankList , handleCloseDialog}) {
  
   useEffect(() => {
     if(bankCode>0){
     const selectedBank =  bankList.find(bank => bank.code === bankCode);
     setBankName(selectedBank.name);

     }
     }, [bankCode]); 
   
     const bankImages = {
    21: './images/hdfc.svg', 
    22: './images/icici.svg',
     4: './images/axis.svg',
     6: './images/BOB.svg', 
    32: './images/kotak_mahindra.svg',
    48: './images/sbi.svg',
    59: './images/yes.svg',
    73: './images/citi.svg',
    76: './images/hsbc.svg',
    41: './images/rbl.svg',
    45: './images/standardchartered.svg',
    27: './images/indusind.svg',
    84: './images/amexbank.svg',
    20: './images/federal.svg',
    85: './images/aubank.svg',
    24: './images/idfc.svg',
    292: './images/onecard.svg',
    23: './images/idbi.svg',
    9: './images/canara.svg',
   
};

    const [selectEmiDuration, setEmiDuration] = React.useState('');

    const handleSelectChange = (event) => {
        setNBerror(false);
        setEmiDuration(event.target.value);
         const selectedDurationCode = event.target.value;
         // Find the selected month from the months array
        const selectedMonth = months.find((month) => month.code === selectedDurationCode);

    // If a matching month is found, set the processing fee
        if (selectedMonth) {
            setProcessingFees(selectedMonth.processingFees); // Set the processing fee based on selected duration
        } else {
            setProcessingFees(''); // If no match, reset the processing fee
        }
        
    };
    
    
    const [months, setMonths] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isEligible, setIsEligible] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const [bankName, setBankName] = useState('');
    const [binMismatch, setBinMismatch] = useState(false);

    useEffect(() => {
        const fetchMonths = async () => {
            setLoading(true);
            try {
                const response = await fetch(`/pay/emiDetails/monthCode?bankId=${bankCode}&mode=${mode}&orderNo=${displayOrderNo}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                setMonths(data);
            } catch (error) {
                console.error("Error fetching month data:", error);
            } finally {
                setLoading(false);
            }
        };
        
        if (bankCode !== '-1' && ![80, 92, 93, 236, 241].includes(bankCode)) {
            fetchMonths();
        } else {
            setMonths([]);
            setLoading(false);
        }

        console.log('months'+months);
    }, [bankCode]);
    
    const [showVisaNetwork, setVisaNetwork] = useState(false);
    const [expiryMonthYear, setExpiryMonthYear] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expity, setExpiry] = useState('');
    const [cvv, setCvv] = useState('');
    const [name , setName] = useState('');
    const [cardNumberError, setCardNumberError] = useState('');
    const [cardCVVError, setCardCVVError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [showCardNameError , setshowCardNameError] = useState(false);
    const [cardNameError, setCardNameError] = useState('As mentioned on your credit card');
    const [txnurl , settxnurl ] = useState('');
    const [pgpayload , setpgpayload] = useState('');
    const [showLoader, setshowLoader] = useState(false);
    const [formHtml, setFormHtml] = useState('');
    const [showForm, setShowForm] = useState(0);
    const [rupayMap , setRupayMap] = useState('');
    const [NBerror, setNBerror] = useState(false);
    const [processingFees, setProcessingFees] = useState('');
    let form;
    let data;
    
      
    const getCardNetwork = (cardNumber) => {
       const newCardNumber = cardNumber.replace(/\s+/g, ''); 
       if(newCardNumber.length>5){
        const bin = newCardNumber.substring(0, 6);
        const visaPattern = /^4/;
         const mastercardPattern = /^(5[1-5][0-9]{4}|222[1-9][0-9]|22[3-9][0-9]{2}|2[3-6][0-9]{3}|27[01][0-9]{2}|2720[0-9])/;
        const amexPattern = /^3[47]/;
        const discoverPattern = /^6(?:011|5[0-9]{2})/;
        const rupayPattern = /^(508[5-9][0-9]|6069[8-9][5-9]|60698[5-9]|6069[9][0-9]|607[0-9]{3}|6080[0-9]{2}|6521[5-9][0-9]|652[2-9][0-9]{2}|6530[0-9]{2}|6531[0-4][0-9])/;
        const dinersPattern = /^3(?:0[0-5]|[68][0-9])[0-9]/;
         if (mastercardPattern.test(bin)) {
            return 'mastercard';
        } else if (visaPattern.test(bin)) {
            return 'visa';
        } else if (amexPattern.test(bin)) {
            return 'amex';
        }else if (dinersPattern.test(bin)) {
           return 'diners';
        }
        else if (rupayPattern.test(bin)){
            return 'rupay';
        } 
         else if (discoverPattern.test(bin)) {
            return 'discover';
        } 
        else {
            return 'card';
        }
        }else{
        return 'card';
        }
    };
	

  const handleCvvChange = (event) => {
    const inputValue = event.target.value;
     
    if (!isNaN(inputValue) && inputValue.length <= 4) {
       setCvv(inputValue);
       
    }
  };

const handleExpiryChange = (event) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    if (/^[2-9]/.test(value)) {
        value = '0' + value;
    }
    if (value.length >= 2 && value.indexOf('-') === -1) {
        value = value.slice(0, 2) + '-' + value.slice(2);
    }
    const parts = value.split('-');
    if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '-' + parts[1].slice(0, 2);
    }
    setExpiryMonthYear(value);
};

const handleNameClick = () => {

setCardNameError('As mentioned on your credit card');
setshowCardNameError(false);

};


const handleExpiryClick = () => {
      setCardExpiryError('');
     if (expiryMonthYear === 'MM-YY') {
     setExpiryMonthYear('');
    }
  };

    
  
    
	
  const handleCvvClick = () => {
     setCardCVVError('');
     if (cvv === '****') {
      setCvv('');
     
    }
  };
  const handleCardNumberChange = (event) => {
        const value = event.target.value;
        const sanitizedValue = value.replace(/\D/g, '').slice(0, 16);
        const formattedValue = sanitizedValue.replace(/(.{4})/g, '$1 ').trim();
    	 setCardNumber(formattedValue);	
       // setCardNumber(sanitizedValue);
        
        if (sanitizedValue.length < 6) {
           setCardNumberError('');
           setBinMismatch(false);
           return;
        }

        if (sanitizedValue.length > 5) {
        debugger;
          const cardBin = sanitizedValue.slice(0, 6);
          const checkEligibility = async () => {
            setLoading(true);
            setErrorMessage('');
            try {
                const response = await fetch(`/pay/emiDetails/eligibility?cardBin=${cardBin}&bankId=${bankCode}&mode=${mode}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();

                if (data.isEligible === '1') {
                    const validator = new CardValidator();
                    const isBinEligible = await validator.checkEmiBinEligibility(cardBin, bankCode, mode, displayOrderNo);
                    if (isBinEligible) {
                        setCardNumberError('');
                        setIsEligible(true);
                        setBinMismatch(false);
                    } else {
                        setIsEligible(false);
                        setBinMismatch(true);
                        setCardNumberError('Selected bank doesn’t match the card. Please choose the correct bank or try another card.');
                    }
                } else {
                   setIsEligible(false);
                   setBinMismatch(false);
                   setErrorMessage("Card is not eligible for EMI");
                }
            } catch (error) {
                console.error("Error checking EMI eligibility:", error);
            } finally {
                setLoading(false);
            }
          };
          checkEligibility();
        }
    };

const handleNameChange = (event) => {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\s]/g, '');
    setName(value);
};

    const handleCardNumberClick = () => {
     setCardNumberError('');
        if(cardNumber === 'XXXX-XXXX-XXXX-XXXX'){
         setCardNumber('');
        }
        
    };
    const handleKeyDown = (event) => {
        // Allow backspace key
        if (event.key === 'Backspace') {
            setExpiryMonthYear((prevValue) => prevValue.slice(0, -1));
        }
    };
      const handlePayNow = async () => {
      
      const queryParameters = new URLSearchParams(window.location.search);
      const mode = "lowCostEMI";
      let emiNo = cardNumber;
      emiNo = emiNo.replace(/\s+/g, '');
      let emiCardHolder = name;
      let emiCVV = cvv;
      let orderNo = queryParameters.get("orderNo");
      let [month, year] = expiryMonthYear.split('-');
      let isOptSi = '0';
      let tenure = '68' ;
      let emiMobNo = '1234412345'
    
      console.log('year'+ year);
      const validator = new CardValidator();
      let isValid = false;
      setCardCVVError('');
      setCardExpiryError('');
      setCardNameError('');
      setCardNumberError('');

     if (binMismatch) {
       setCardNumberError('Selected bank doesn’t match the card. Please choose the correct bank or try another card.');
       return;
      }

      if(validator.isValidCardNumber(emiNo)){
         if(validator.isValidCardName(emiCardHolder)){
            if(validator.isValidExpiry(month,year)){
                if(validator.isValidCVV(emiCVV)){
                if(selectEmiDuration !==''){
                   isValid = true;
                   }else{
                   setNBerror(true);
                   }
                   
                }else{
                setCardCVVError('Please enter a valid CVV');
                }
            }else{
             setCardExpiryError('Please enter a valid expiry');
            }
         }else{
          setshowCardNameError(true);
          setCardNameError('Please enter a valid card holder name');
         }
       }else{
        setCardNumberError('Please enter a valid card number');
     }
       year = '20'+year;
      if(isValid){
      	setshowLoader(true);
        emiNo = encodeURIComponent(validator.encrypt(emiNo, secret).toString());
        emiCVV = encodeURIComponent(validator.encrypt(emiCVV, secret).toString());
        emiCardHolder = encodeURIComponent(validator.encrypt(emiCardHolder, secret).toString());
        month = encodeURIComponent(validator.encrypt(month, secret).toString());
        year = encodeURIComponent(validator.encrypt(year, secret).toString());
        tenure = encodeURIComponent(validator.encrypt(selectEmiDuration.split("_")[1], secret).toString());
        emiMobNo = encodeURIComponent(validator.encrypt(emiMobNo, secret).toString());
        let bcode = encodeURIComponent(validator.encrypt(selectEmiDuration.split("_")[0], secret));
        let bankId = encodeURIComponent(validator.encrypt(bankCode, secret).toString());
        
        
            
      const cardData = {
            emiNo,
            emiCardHolder,
            emiExpiryMonth:month,
            emiExpiryYear:year,
            emiCVV,
            orderNo,
            emiBankId : bankId,
            emiBankCode : bcode,
            tenure,
            emiMobNo,
            mode : mode
        };
	
   
    try {
        const response = await fetch('/pay/securePayment/process/paymentui', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
             body: JSON.stringify(cardData)
        });
        data = await response.json();
        setshowLoader(false);
        console.log(data);
      if(data.as ===1){

        if(data.pgPayload.form){
            const formHtml = data.pgPayload.form;
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = formHtml;
      
            const formElement = tempContainer.querySelector('form');
            document.body.appendChild(formElement);
            formElement.submit();
            }

    
     
      
      else if(data.txnURL){
       settxnurl(data.txnURL);
       setpgpayload(data.pgPayload);
       await delay(1500);
       form = document.getElementById('testForm');
       form.submit();
      
      }
      
      
      } else if(data.as ===2){
       window.location.href = data.txnURL1;
      
      }else if(data.as===3){
        if(data.mastRupay){
        setShowForm(2);
        setRupayMap(data.mastRupay);
       }
        else{
          setFormHtml(data.form);
          setShowForm(data.showForm);
          await delay(1500);
        }
      
      }else if(data.error === 1){
        window.location.reload();      
        } 
    } catch (error) {
        console.error('Error:', error);
         window.location.reload();
    }
    
     
  }
  
  
};


const delay = millis => new Promise((resolve, reject) => {
  setTimeout(_ => resolve(), millis)
});
    
    
  return (
  <>
  
    
  {showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
    {pgpayload && (
    <form method="post" action={txnurl} id="testForm">
        {Object.keys(pgpayload).map((key, index) => (
            <input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
        ))}
    </form>
)}
   
  {showForm === 1 && (
  <div style={{
    position: 'fixed', // Ensure this div covers the whole viewport
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white', // Blank background color
    display: 'flex',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    zIndex: 9999 // Ensure it's on top of other content
  }}>
    <div dangerouslySetInnerHTML={{ __html: formHtml }} />
  </div>
)}


 {showForm === 2 && (
  <div style={{
    position: 'fixed', // Ensure this div covers the whole viewport
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white', // Blank background color
    //display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    zIndex: 9999 // Ensure it's on top of other content
  }}>
     <MasterCardRupayForm  mastRupay={rupayMap} />
  </div>
)}
   
    <div className='enter-bank-deatils'>
        <div className='bank-info-edit'>
            <div className='head'>
                <p>
                    <img src={bankImages[bankCode]} alt={bankName}/> <span className='text-base align-middle px-2'>{bankName}</span>
                </p>
                <p className='edit-pen'>
                    <Button><FontAwesomeIcon icon={faPencilAlt} onClick={()=> handleCloseDialog ? handleCloseDialog() : null}/></Button>
                </p>
            </div>
        </div>
        <h5>
            Enter your credit card details
        </h5>
        <div className='card-detail-form'>
             
            <Grid container spacing={3}>
                <Grid item md={12} xs={12}  className={`debit-card ${getCardNetwork(cardNumber)}`}>
                    <TextField
                       id="cardNumber"
                        label="Credit Card number"
                          placeholder="XXXX-XXXX-XXXX-XXXX"
                        value={cardNumber}
                        fullWidth
                        error={!!cardNumberError}
                        helperText={cardNumberError}
                        style={{borderRadius:'8px'}}
                        onClick={handleCardNumberClick}
                        onChange={handleCardNumberChange}
                    />
                </Grid>
               <Grid item md={12} xs={12}>
                 <TextField
       	 id="name"
       	 label="Enter your name"
       	 fullWidth
       	 onChange={handleNameChange}
      	         onClick ={handleNameClick}
      	         error={showCardNameError}
                 helperText={cardNameError}
                 value={name}
  			  />
		</Grid>
                <Grid item md={6} xs={12}>
                    <TextField
                        id="expiry"
                        label="Expiry Month & Year"
                          placeholder="MM-YY"
                         error={!!cardExpiryError}
                            helperText={cardExpiryError}
                       value = {expiryMonthYear}
                       onClick ={handleExpiryClick}
                        onChange={handleExpiryChange}
                        onKeyDown={handleKeyDown}
                        fullWidth
                        
                    />
                </Grid>
                <Grid item md={6} xs={12}  className='cvv-box'>
                    <TextField
                        id="cvv"
                        label="CVV"
                        type="password"
                        value = {cvv}
                          placeholder="***"
                         error={!!cardCVVError}
                         helperText={cardCVVError}
                         onChange={handleCvvChange}
                         onClick={handleCvvClick}
                         fullWidth
                    />
                </Grid>              

                <Grid item md={12} xs={12} >
                    <FormControl fullWidth className='form-control'>
                    <InputLabel id="demo-simple-select-label">Select EMI duration</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectEmiDuration}
                        label="Bank Name"
                        onChange={handleSelectChange}
                        disabled={loading}
                    >
                         {loading ? (
                        <MenuItem value="" disabled>Loading...</MenuItem>
                    ) : (
                        months.map((val) => (
                            <MenuItem key={val.code} value={val.code}>
                                {val.month} Months
                            </MenuItem>
                        ))
                    )}
                    </Select>
                    </FormControl>
                </Grid>
                 {NBerror && (
 		 <p style={{ color: 'red', paddingTop: '10px', marginLeft: '27px' }}>
  	      Please select a valid tenure!
		  </p>
		)}	
            </Grid>
            <div className='autopay-check'>
                <Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
                Pay now
            </Button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              {processingFees && processingFees.trim() !== '' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span>
                  <ImageComponents name={"notesIcon"} />
                </span>
                <h5 style={{ color: 'rgb(208, 0, 0)', fontWeight: 'bold', fontSize: '12px', margin: 0 }}>
                  {processingFees}
                </h5>
        </div>
        )}
</div> 
        
        </div>
    </div>
    </>
  )
}

export default LowCostEmiCreditCardDetails
